import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      searchValid: false,
      BCN: "",
      showOrginal: true,
      disableBCN: false,
      serialNum: "",
      disableSerialNum: false,
      ESN: "",
      disableESN: false,
      RLPId: "",
      disableRLPId: false,
      showStatusDetails: false,
      disableSearch: true,
      btnAction: "",
      actionData: [],
      showActionBtn: false,
      apiObj: {
        unit: "",
        type: 0,
        main_key: 0,
        action: "",
        user_id: 0,
      },
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.showOrginal=false;
      this.$nextTick(() => {
      this.showOrginal = true;
      })
      this.BCN = "";
      this.disableBCN = false;
      this.serialNum = "";
      this.disableSerialNum = false;
      this.ESN = "";
      this.disableESN = false;
      this.RLPId = "";
      this.disableRLPId = false;
      this.$refs.searchForm.resetValidation();
      this.showStatusDetails = false;
      this.disableSearch = true;
      this.showActionBtn = false;
      this.btnAction = "";
      this.actionData = [];
      this.apiObj = {
        unit: "",
        type: 0,
        main_key: 0,
        action: "",
        user_id: 0,
      };
    },
    //Input BCN
    inputBCN() {
      this.serialNum = "";
      this.disableSerialNum = true;
      this.ESN = "";
      this.disableESN = true;
      this.RLPId = "";
      this.disableRLPId = true;
      this.disableSearch = false;
      this.apiObj = {
        unit: "",
        type: 0,
        main_key: 0,
        action: "",
        user_id: 0,
      };
    },
    //Input Serial number
    inputSerialNum() {
      this.BCN = "";
      this.disableBCN = true;
      this.ESN = "";
      this.disableESN = true;
      this.RLPId = "";
      this.disableRLPId = true;
      this.disableSearch = false;
      this.apiObj = {
        unit: "",
        type: 0,
        main_key: 0,
        action: "",
        user_id: 0,
      };
    },
    //Input ESN
    inputESN() {
      this.serialNum = "";
      this.disableSerialNum = true;
      this.BCN = "";
      this.disableBCN = true;
      this.RLPId = "";
      this.disableRLPId = true;
      this.disableSearch = false;
      this.apiObj = {
        unit: "",
        type: 0,
        main_key: 0,
        action: "",
        user_id: 0,
      };
    },
    //Input RLP ID
    inputRLPId() {
      this.serialNum = "";
      this.disableSerialNum = true;
      this.ESN = "";
      this.disableESN = true;
      this.BCN = "";
      this.disableBCN = true;
      this.disableSearch = false;
      this.apiObj = {
        unit: "",
        type: 0,
        main_key: 0,
        action: "",
        user_id: 0,
      };
    },
    //Search button click event
    async onSearchClick() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.apiObj.user_id = parseInt(this.userId);
      this.apiObj.unit = "";
      this.apiObj.type = 0;
      this.apiObj.main_key = 0;
      this.apiObj.action = "";
      if (this.BCN !== "" && this.BCN !== undefined) {
        this.apiObj.unit = this.BCN;
        this.apiObj.type = 1;
      }
      if (this.serialNum !== "" && this.serialNum !== undefined) {
        this.apiObj.unit = this.serialNum;
        this.apiObj.type = 2;
      }
      if (this.ESN !== "" && this.ESN !== undefined) {
        this.apiObj.unit = this.ESN;
        this.apiObj.type = 3;
      }
      if (this.RLPId !== "" && this.RLPId !== undefined) {
        this.apiObj.unit = this.RLPId;
        this.apiObj.type = 4;
      }
      this.axios
        .post("/rv/reverse_tran", this.apiObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responsedata = JSON.parse(response.data.body.message);
            if (responsedata.length !== 0 && responsedata !== undefined) {
              this.btnAction = responsedata[0]?.caption;
              this.showActionBtn = true;
              const parsedData = Object.fromEntries(
                responsedata[0]?.message.split("||").map((item) => {
                  const [key, ...value] = item.split(":");
                  return [key.trim(), value.join(":").trim()];
                })
              );
              this.actionData = parsedData;
              this.BCN = responsedata[0]?.bcn;
              this.serialNum = responsedata[0]?.serialno;
              this.ESN = responsedata[0]?.esn;
              this.RLPId = responsedata[0]?.license_plate;
              this.apiObj.main_key = responsedata[0]?.main_key;
              this.apiObj.action = responsedata[0]?.action;
              this.disableBCN = true;
              this.disableSerialNum = true;
              this.disableESN = true;
              this.disableRLPId = true;
              this.disableSearch = true;
              this.showStatusDetails = true;
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          this.btnAction = "";
          this.showActionBtn = false;
          this.actionData = [];
          this.BCN = "";
          this.serialNum = "";
          this.ESN = "";
          this.RLPId = "";
          this.disableBCN = false;
          this.disableSerialNum = false;
          this.disableESN = false;
          this.disableRLPId = false;
          this.disableSearch = false;
          this.showStatusDetails = false;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Last action click event
    actionEvent() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.apiObj.unit = "";
      this.apiObj.type = 0;
      this.axios
        .post("/rv/reverse_tran", this.apiObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.resetFunction();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
